module.exports = __webpack_public_path__ + "img/img84.51b24e5b.svg";